import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Container, Reveal } from "@/components/Reveal";
import USMap, { MapLegend } from "@/components/USMap";

export default function ServiceAreasPreview() {
  return (
    <section className="relative overflow-hidden bg-navy-dark py-24 text-white md:py-32">
      <Container>
        <div className="grid grid-cols-1 items-center gap-14 lg:grid-cols-2 lg:gap-20">
          <div>
            <p className="overline text-energy">Service Areas</p>
            <h2 className="mt-4 font-heading text-3xl font-semibold leading-[1.1] tracking-tight sm:text-4xl lg:text-5xl">
              National coverage. Availability varies by state.
            </h2>
            <p className="mt-6 max-w-lg text-lg leading-relaxed text-white/65">
              We operate across eligible deregulated markets nationwide. Electricity
              and natural gas choice depends on your state, and Virtual Power Plant
              Network hosting is currently evaluated in Texas and Illinois.
            </p>

            <div className="mt-8">
              <MapLegend dark />
            </div>

            <Link
              to="/service-areas"
              data-testid="service-areas-preview-cta"
              className="mt-10 inline-flex items-center gap-2 bg-electric px-7 py-4 text-sm font-medium text-white transition-transform hover:scale-[0.97] hover:bg-electric-hover"
            >
              View Service Areas
              <ArrowUpRight className="h-4 w-4" />
            </Link>
          </div>

          <Reveal delay={0.15}>
            <div className="relative rounded-sm border border-white/10 bg-navy/40 p-4 md:p-8">
              <USMap className="relative" />
            </div>
          </Reveal>
        </div>
      </Container>
    </section>
  );
}
